// "Report a language issue": the kinds a learner can choose, the limits of a report and the states an admin sets.
// Pure data, shared by the report dialog, /api/reports, /api/admin/reports and /admin/reports.

export const REPORT_COURSES = ['prakrit', 'sanskrit'] as const

export type ReportCourse = (typeof REPORT_COURSES)[number]

export const REPORT_KIND_IDS = ['spelling', 'grammar', 'meaning', 'audio', 'other'] as const

export type ReportKind = (typeof REPORT_KIND_IDS)[number]

export const REPORT_KINDS: { id: ReportKind, hi: string, en: string }[] = [
    { id: 'spelling', hi: 'वर्तनी', en: 'Spelling' },
    { id: 'grammar', hi: 'व्याकरण या रूप', en: 'Grammar or form' },
    { id: 'meaning', hi: 'अर्थ या अनुवाद', en: 'Meaning or translation' },
    { id: 'audio', hi: 'उच्चारण या ऑडियो', en: 'Pronunciation or audio' },
    { id: 'other', hi: 'अन्य', en: 'Other' }
]

export const REPORT_STATUSES = ['new', 'resolved', 'dismissed'] as const

export type ReportStatus = (typeof REPORT_STATUSES)[number]

export const REPORT_LIMITS = {
    messageMin: 10,
    messageMax: 1000,
    page: 300,
    itemKey: 300,
    itemLabel: 200,
    email: 254,
    note: 500
}

/** A path of this site ("/learn/u1-…"), never "//other.site" or a full URL, so it is safe to link to. */
export const isSitePath = (value: string): boolean => /^\/(?![/\\])\S*$/.test(value)

export const reportKindLabel = (kind: string): { hi: string, en: string } => (
    REPORT_KINDS.find(k => k.id === kind) ?? { hi: kind, en: kind }
)
